import { IconGraphic } from '@design-system/components/atoms/icon/entities/icon.types';
import { IconProductOutlineGraphics } from '@design-system/components/atoms/icon/entities/icon-product-outline.graphics';
import { IconChevronOutlineGraphics } from '@design-system/components/atoms/icon/entities/icon-chevron-outline.graphics';
import { IconChevronFilledGraphics } from '@design-system/components/atoms/icon/entities/icon-chevron-filled.graphics';
import { IconArrowsOutlineGraphics } from '@design-system/components/atoms/icon/entities/icon-arrows-outline.graphics';
import { IconCommonOutlineGraphics } from '@design-system/components/atoms/icon/entities/icon-common-outline.graphics';
import { IconCommonFilledGraphics } from '@design-system/components/atoms/icon/entities/icon-common-filled.graphics';
import { IconBrandedFilledGraphics } from '@design-system/components/atoms/icon/entities/icon-branded-filled.graphics';

export const IconGraphics: { [key: string]: IconGraphic[] } = {
  ...IconProductOutlineGraphics,
  ...IconChevronOutlineGraphics,
  ...IconChevronFilledGraphics,
  ...IconArrowsOutlineGraphics,
  ...IconCommonOutlineGraphics,
  ...IconCommonFilledGraphics,
  ...IconBrandedFilledGraphics,
};
